import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { MinusIcon } from 'foundations-assets/icons/components/MinusIcon';
import { AddPlaylistIcon, RemovePlaylistIcon } from './PlaylistAddRemoveButtons';
import I18n from 'I18n';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddRemovePlaylistSearchItemIcon = ({
  onClick,
  isAdded
}) => {
  const handleOnClick = e => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  if (isAdded) {
    return /*#__PURE__*/_jsx(Button, {
      "aria-label": I18n.text('learningCenter.savedItems.playlistDetails.removeFromPlaylist'),
      onClick: handleOnClick,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(RemovePlaylistIcon, {
        padding: "100",
        size: "400"
      })
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    "aria-label": I18n.text('learningCenter.savedItems.playlistDetails.addToPlaylist'),
    onClick: handleOnClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(AddPlaylistIcon, {
      padding: "100",
      size: "400"
    })
  });
};
export const AddRemovePlaylistSearchItemButton = ({
  onClick,
  isAdded
}) => {
  const handleOnClick = e => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  const {
    isMobile
  } = useMediaQuery();
  const Icon = isAdded ? MinusIcon : AddIcon;
  const text = isAdded ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.playlistDetails.addContentToPlaylistModal.remove"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.playlistDetails.addContentToPlaylistModal.add"
  });
  if (isMobile) {
    return /*#__PURE__*/_jsx(IconButton, {
      onClick: handleOnClick,
      shape: "circle",
      size: "small",
      use: "secondary",
      children: /*#__PURE__*/_jsx(Icon, {
        size: "100"
      })
    });
  }
  return /*#__PURE__*/_jsxs(Button, {
    onClick: handleOnClick,
    size: "small",
    use: "tertiary-light",
    children: [/*#__PURE__*/_jsx(Icon, {
      size: "100"
    }), text]
  });
};